(() => {
  const init = () => document.querySelectorAll('[data-j-journal-library]').forEach((root) => {
    if (root.dataset.libraryReady === 'true') return;
    const cards = [...root.querySelectorAll('[data-journal-group]')];
    const controls = root.querySelector('.j-journal-library__filters');
    const buttons = [...root.querySelectorAll('[data-journal-filter]')];
    const status = root.querySelector('[data-journal-status]');
    if (!cards.length || !controls || !status || !buttons.length) return;
    const count = (group) => cards.filter((card) => group === 'alle' || card.dataset.journalGroup === group).length;
    root.querySelectorAll('[data-journal-count]').forEach((node) => { node.textContent = count(node.dataset.journalCount); });
    const choose = (button) => {
      const group = button.dataset.journalFilter;
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach((card) => { card.hidden = group !== 'alle' && card.dataset.journalGroup !== group; });
      root.dataset.journalSelected = group;
      const total = count(group);
      status.textContent = `${total} Artikel · ${button.querySelector('span').textContent}`;
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => choose(button));
      button.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault(); buttons[next].focus(); choose(buttons[next]);
      });
    });
    const initial = buttons.find((button) => `#${button.dataset.journalFilter}` === location.hash) || buttons[0];
    choose(initial);
    controls.hidden = false;
    root.dataset.libraryReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
